/**
 * Free Shipping Upsell - Add to Cart Handler
 * Uses event delegation so it works even when buttons are dynamically loaded
 */
(function() {
  // Guard against multiple registrations
  if (window.__freeShippingUpsellInitialized) return;
  window.__freeShippingUpsellInitialized = true;

  document.addEventListener('click', async (e) => {
    const button = e.target.closest('.free-shipping-upsell__add-button');
    if (!button) return;

    const variantId = button.dataset.variantId;
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: String(variantId),
            quantity: 1
          }]
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || 'Failed to add to cart');
      }

      const result = await response.json();
      console.log('Item added:', result);

      // Get updated cart
      const cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartResponse.json();

      // Get all cart items components and their section IDs
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionsToUpdate = new Set();
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sectionsToUpdate.add(item.dataset.sectionId);
        }
      });

      // Fetch updated sections
      const root = window.Shopify?.routes?.root || '/';
      const sectionsUrl = `${root}?sections=${Array.from(sectionsToUpdate).join(',')}`;
      const sectionsResponse = await fetch(sectionsUrl, { credentials: 'same-origin' });
      const sectionsData = await sectionsResponse.json();

      // Update cart items components with new HTML
      cartItemsComponents.forEach((cartItems) => {
        const sectionId = cartItems.dataset.sectionId;
        if (sectionId && sectionsData[sectionId]) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sectionsData[sectionId], 'text/html');
          const newCartItems = doc.querySelector('cart-items-component');

          if (newCartItems) {
            cartItems.innerHTML = newCartItems.innerHTML;
          }
        }
      });

      // Dispatch cart update event
      const cartUpdateEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'free-shipping-upsell',
          data: {
            source: 'free-shipping-upsell',
            itemCount: cart.item_count,
            variantId: String(variantId),
            sections: sectionsData
          }
        }
      });
      document.dispatchEvent(cartUpdateEvent);

      button.textContent = 'Added!';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 2000);
    } catch (err) {
      console.error('Error adding to cart:', err);
      button.disabled = false;
      button.textContent = originalText;
      alert('Could not add to cart. Please try again.');
    }
  });
})();
